import {clsx} from 'clsx'
import styles from './HeaderDivider.module.css'

interface HeaderDividerProps {
  className?: string
}

export function HeaderDivider({className}: HeaderDividerProps) {
  return <div className={clsx(styles.divider, className)} aria-hidden="true" />
}
